import React from 'react'
import { Heading2 } from '@/components/ui/typography'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 3rem;
  button {
    text-transform: uppercase;
    cursor: pointer;
    height: 32px;
    width: 80px;
    background: #fff;
    text-align: center;
    &:hover {
      background: rgba(0, 0, 0, 0.05);
      color: rgba(0, 0, 0, 0.65);
      color: #40a9ff;
      background-color: #fff;
      border-color: #40a9ff;
      outline: 0;
    }
  }
`
interface Props {
  header: string
  onClick(): void
}

export const ClientDetailsNoMatch: React.FC<Props> = ({ onClick, header }) => (
  <Container>
    <Heading2>{header || 'For this entity test cannot be added.'}</Heading2>
    <button onClick={onClick}>Ok</button>
  </Container>
)
